import React from 'react';
import { FaShareAlt } from 'react-icons/fa';

import { mainConfig } from '../../../config/config.provider';
import { DeviceDetector } from '../../../utils/helper/browserDetection';
import { SharingItem, SharingList } from './styles.Sharing';
import { SocialMedia } from '../../../config/models';
import { SocialMediaMap } from '../../../config/socialMediaMap';
import { StyleProps } from '../../../styles/models';

const availableShares = [SocialMedia.Facebook, SocialMedia.Twitter, SocialMedia.Whatsapp, SocialMedia.Mail];

export const ShareIcon = ({ type }: { type: SocialMedia }) => (
    <SharingItem hoverColor={SocialMediaMap[type].color}>
        <a
            title={SocialMediaMap[type].alt}
            href={SocialMediaMap[type].link}
            target="_blank"
            rel="noopener noreferrer"
            data-click={`share-${type.toLowerCase()}`}
        >
            {SocialMediaMap[type].icon({ title: type, size: '22px' })}
        </a>
    </SharingItem>
);

export const Sharing: React.FC<StyleProps> = ({ style }) => {
    const share = () => {
        const shareData = {
            title: mainConfig.title,
            text: mainConfig.mobileShareText,
            url: mainConfig.url
        };
        if (DeviceDetector.isMobile && navigator.share) {
            navigator.share(shareData);
        } else {
            alert(
                `Auf einem echten Mobilgerät würde jetzt das native Teilen-Fenster mit folgendem Inhalt aufploppen:\n\n${shareData.title}\n${shareData.text}\n${shareData.url}`
            );
        }
    };

    return (
        <SharingList style={style}>
            {DeviceDetector.isPortrait ? (
                <SharingItem onClick={share}>
                    <FaShareAlt size="22px" title="Teilen" />
                </SharingItem>
            ) : (
                availableShares.map(key => <ShareIcon key={key} type={key} />)
            )}
        </SharingList>
    );
};
